{
  "provenance": "Native compile-time value shaping; exact FT_INT/DECIMAL_LAYER_VALUE_TYPES from includes/functions.php",
  "source_sha256": "15f82790a3b708a3c27ace4dd212b6dd68e2e2eae019b322893472e3fde2c6a7",
  "integer": [
    "requires_class_level",
    "spell_level",
    "ability_does_not_effect_inventory",
    "ability_only_affects_inventory",
    "ability_does_not_provoke_opportunity_attacks",
    "ability_resets_long_rest",
    "acquire_abilities_while_unequipped",
    "aoe_follows_target",
    "attack_ability_throws_the_throwing_weapon_at_target",
    "attack_automatically_hits",
    "attack_automatically_misses",
    "blindsight_blind",
    "body_vanishes_at_zero_vitality",
    "boon",
    "buff_does_not_layer_onto_opposing_team",
    "can_breath_underwater",
    "cannot_be_targeted_by_a_contesting_roll_ability",
    "carrying_capacity_fixed_weight",
    "caster_moves_to_end_point_of_aoe_effect_after_cast",
    "chooseable_targets_in_aoe",
    "consumable",
    "consumes_unit_per_use",
    "contesting_roll_adv_vs_spells",
    "contesting_roll_dis_vs_spells",
    "contesting_roll_successful_for_half_damage",
    "counterspelling_effect",
    "crit_to_hit",
    "disarmed",
    "dispelling_effect",
    "do_not_include_automatic_creature_type_monster_bits",
    "draw_sheathed_weapon_for_attack_ability",
    "effect_can_heal_inventory",
    "effect_can_only_heal_inventory",
    "effect_ends_on_end_of_caster_next_turn",
    "effect_ends_on_start_of_caster_next_turn",
    "effect_ends_on_target_end_of_turn",
    "effect_ends_on_target_start_of_turn",
    "effect_only_affects_opposing_team_type",
    "effect_only_affects_same_team_type",
    "effect_penetration_limitation",
    "fast_draw",
    "feat_repeatable",
    "gather_while_alive",
    "gravequench",
    "hit_to_crit",
    "ignore_ranged_spell_attack_roll_dis_within_an_enemy_reach",
    "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach",
    "immovable",
    "immune_to_ability_upon_successful_contesting_roll_till_long_rest",
    "integrated_object",
    "item_throwable",
    "language_cannot_speak",
    "mass_dispelling_effect",
    "no_actions",
    "no_reactions",
    "non_lethal_attack",
    "object_allows_outside_light_to_pass_through",
    "object_becomes_attached_to_target",
    "object_destroyed_after_duration_complete",
    "object_does_not_grant_environmental_cover",
    "pack_tactics",
    "persistent_aoe",
    "random_generator_constrain_to_environment_type",
    "random_generator_scatter",
    "ranged_loading",
    "reaction_reset",
    "shapeshift_inventory_remains_on_form",
    "shield_shattering_blow",
    "spell_component_material",
    "spell_component_material_consumed",
    "spell_component_somatic",
    "spell_component_verbal",
    "spell_concentration",
    "spell_locked",
    "spell_ritual",
    "spell_scalable_cantrip",
    "spell_upcastable",
    "status_effect_can_be_paused",
    "status_effect_pausable",
    "summon_trigger_on_kill_grants_caster_menace",
    "target_marked_by_caster",
    "target_retries_contesting_roll_on_end_of_turn",
    "transform_into_creature_on_self_zero_vitality_drop_inventory",
    "transform_into_creature_on_self_zero_vitality_equip_inventory",
    "unenchantable",
    "unhindered_attack",
    "user_choice_1_shapeshift_inventory_remains_on_form"
  ],
  "decimal": [
    "weight"
  ]
}
